import React, { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import throttle from 'lodash/throttle'

import { media, colors } from '../variables'

const solutionsStyles = () => {
  let styles = ''

  for (let i = 1; i < 5; i += 1) {
    styles += `
      &:nth-child(${i}) {
        text-align: ${i % 2 === 0 ? 'left' : 'right'};
        ${
          i % 2 === 0 &&
          css`
            justify-content: flex-end;
          `
        }
      }
    `
  }

  return styles
}

const Solution = styled.div`
  width: 100%;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10vh;

  & + & {
    margin-top: 30vh;
  }

  ${solutionsStyles()}

  ${media.mdMax`
    justify-content: center !important;
    text-align: center !important;
    margin-top: 1.5rem !important;
  `}
`

const SolutionContent = styled.div`
  width: 40%;
  ${media.mdMax`
    width: 100%;
  `}
`

const SolutionContainer = styled.div`
  position: relative;
`
const SolutionLine = styled(({ percentage, ...props }) => <div {...props} />)`
  position: absolute;
  left: 50%;
  transform: translate3d(-50%, -30px, 0);
  width: 12px;
  border-radius: 12px;
  height: ${props =>
    `calc(${100 * props.percentage}% + ${50 * props.percentage}px)`};
  background: ${colors['dark-blue']};
  transition: height 50ms linear;

  ${media.mdMax`
    display: none;
  `}
`

let container
const AboutPoints = () => {
  const [percentage, setPercentage] = useState(0.01)
  const onScroll = throttle(() => {
    if (window.innerWidth < 780) {
      return
    }

    if (!container) {
      container = document.getElementById('about-dots')
    }
    const documentHeight = window.innerHeight
    const square = container.getBoundingClientRect()
    const difference = square.height - (square.top + (documentHeight / 3) * 2)
    const calc = difference / square.height

    if (calc < 0.01) {
      setPercentage(0.01)
      return
    }

    if (calc > 1) {
      setPercentage(1)
      return
    }

    setPercentage(calc)
  }, 100)

  useEffect(() => {
    document.addEventListener('scroll', onScroll)
    return () => document.removeEventListener('scroll', onScroll)
  })

  return (
    <SolutionContainer id="about-dots">
      <SolutionLine percentage={percentage} />
      <Solution>
        <SolutionContent>
          La solución que le dará a tu negocio un
          <br />
          <b>giro de 180º.</b>
        </SolutionContent>
      </Solution>
      <Solution>
        <SolutionContent>
          Impulsados a crear experiencias
          <br />
          <b>increíbles.</b>
        </SolutionContent>
      </Solution>
      <Solution>
        <SolutionContent>
          La colaboración entre los expertos del equipo
          <br />
          es <b>nuestro núcleo</b> y queremos impulsar el
          <br />
          crecimiento de los proyectos para ayudar a{' '}
          <b>acelerar la innovación</b>.
        </SolutionContent>
      </Solution>
      <Solution>
        <SolutionContent>
          Creando una red de
          <br />
          <b>
            colaboración remota y<br />
            oportuna
          </b>
        </SolutionContent>
      </Solution>
    </SolutionContainer>
  )
}

export default AboutPoints
